import React, { useEffect, useState } from "react";
import { Box, Tooltip, Typography, Stack, Avatar } from "@mui/material";
import moment from "moment";
import appcolors from "../../constants/Colors";
import { allImages, appFonts } from "../../assets";

const CustomEvent = ({ event }) => {

  const [open, setOpen] = useState(false);

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const start = moment(event.start);
  const end = moment(event.end);
  const duration = moment.duration(end.diff(start));

  // Format the duration to show hours and minutes
  const hours = duration.hours();
  const minutes = duration.minutes();
  let durationText = "";

  if (hours > 0) {
    durationText = `${hours}h`;
  }

  if (minutes > 0) {
    if (hours > 0) {
      durationText += ` ${minutes}m`;
    } else {
      durationText = `${minutes}m`;
    }
  }

  const renderBlockedTimeToltip = () => {
    return (
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        p={1}
        bgcolor={appcolors.primary}
        color={appcolors.white}
      >
        <Typography>Blocked Time</Typography>
        <Typography variant="body2">
          {`${moment(event.start).format("h:mm A")} - ${moment(
            event.end
          ).format("h:mm A")}`}
        </Typography>
      </Stack>
    );
  };

  const renderAppointments = () => {
    return (
      <>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          p={1}
          bgcolor={appcolors.primary}
          color={appcolors.white}
        >
          <Typography variant="body2">
            {`${moment(event.start).format("h:mm A")} - ${moment(
              event.end
            ).format("h:mm A")}`}
          </Typography>
          <Typography variant="body2">{event?.type}</Typography>
        </Stack>
        <Stack p={1.5} direction={"row"} alignItems={"center"} gap={1}>
          <Avatar src={event?.user?.image} sx={{ height: 50, width: 50 }} />
          <Box>
            <Typography variant="body2">{event?.user?.username}</Typography>
            <Typography
              variant="body2"
              fontSize={"0.75rem"}
              color={appcolors.charcolGrey}
            >
              {event?.user?.email}
            </Typography>
          </Box>
        </Stack>
        <Stack
          p={1}
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"flex-start"}
        >
          <Box>
            <Typography
              variant="body1"
              fontSize={"0.89rem"}
              fontWeight={400}
              fontFamily={appFonts.Poppins}
            >
              {event.title}
            </Typography>
            <Typography
              variant="body1"
              fontSize={"0.75rem"}
              fontWeight={400}
              fontFamily={appFonts.Poppins}
            >
              <strong>Status:</strong> {event.status}
            </Typography>
            <Typography
              variant="body1"
              fontSize={"0.75rem"}
              fontWeight={400}
              fontFamily={appFonts.Poppins}
              color={appcolors.charcolGrey}
            >
              Duration: {durationText}
            </Typography>
          </Box>
          <Typography
            variant="body1"
            fontSize={"0.89rem"}
            fontWeight={400}
            fontFamily={appFonts.Poppins}
          >
            SAR {event.price || 0}
          </Typography>
        </Stack>
      </>
    );
  };

  return (
    <Tooltip
      title={
        event.status === "Blocked"
          ? renderBlockedTimeToltip()
          : renderAppointments()
      }
      open={open}
      onClose={handleTooltipClose}
      onOpen={handleTooltipOpen}
      // disableInteractive
      disableHoverListener
      disableTouchListener
      PopperProps={{
        sx: {
          "& .MuiTooltip-tooltip": {
            padding: "0px",
            margin: 0,
            color: "#000000",
            backgroundColor: "#ffffff",
            border: "1px solid #ddd",
            boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
            borderRadius: "6px",
            overflow: "hidden",
            minWidth: "300px",
            maxWidth: "400px",
          },
        },
      }}
    >
      <Box
        onMouseEnter={handleTooltipOpen}
        onMouseLeave={handleTooltipClose}
        onTouchStart={handleTooltipOpen}
        className="custom-event"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            variant="body1"
            fontSize={"0.8rem"}
            display={"block"}
            overflow={"hidden"}
            textOverflow={"ellipsis"}
            whiteSpace={"nowrap"}
          >
            {`${moment(event.start).format("h:mm A")} - ${moment(
              event.end
            ).format("h:mm A")}`}
          </Typography>
          <Typography
            variant="body1"
            fontSize={"0.75rem"}
            fontWeight={600}
            noWrap
            ml={2}
          >
            Status: {event.status}
          </Typography>
        </Box>
        <Typography variant="body1" fontSize={"0.75rem"} lineHeight={"normal"}>
          {event.title}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default CustomEvent;
